import * as React from "react";
const SvgTriangleFilled = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M21 21H3l9-18Z", fill: "currentColor" }));
export default SvgTriangleFilled;
